export const jobs = [
    {
        id:1,
        link:'https://jatinverma.org/wp-content/uploads/2019/06/How-to-Prepare-for-UPSC-PRelims-2020.pdf',
        subject:'UPSC',
        startGrad:'from-[#4AC29A]',
        endGrad:'to-[#1CB5E0]',
        content:'This domain offers the jobs as the body of government officials at different posts like IAS, IPS etc. '
    },
    {
        id:2,
        link:'https://www.vssut.ac.in/lecture_notes/lecture1428551142.pdf',
        subject:'SDE',
        startGrad:'from-[#56CCF2]',
        endGrad:'to-[#2F80ED]',
        content:'This role includes directing and participating in programming activities, monitoring and evaluating system performance'
    },
    {
        id:3,
        link:'https://www.ibs-b.hu/documents/277/the_role_of_the_manager.pdf',
        subject:'Manager',
        startGrad:'from-[#159957]',
        endGrad:'to-[#155799]',
        content:'Management is the main department of any team who acts as the main leader and gets all the work done on time by scheduling task deadlines.'
    },
    {
        id:4,
        link:'https://www.cybok.org/media/downloads/CyBOK-version-1.0.pdf',
        subject:'Cyber Security',
        startGrad:'from-[#FFAFBD]',
        endGrad:'to-[#ffc3a0]',
        content:'Skills to implement high-tech solutions to defend against hacking, malware, insider threats and all types of cybercrime.'
    },
    {
        id:5,
        link:'https://www.diva-portal.org/smash/get/diva2:1481306/FULLTEXT01.pdf',
        subject:'Standup Comedy',
        startGrad:'from-[#DCE35B]',
        endGrad:'to-[#45B649]',
        content:'Stand-up comedy is a comedic performance to a live audience in which the performer addresses the audience directly from the stage'
    },
    {
        id:6,
        link:'https://repo.zenk-security.com/Magazine%20E-book/EN-Ethical%20Hacking.pdf',
        subject:'Ethical Hacking',
        startGrad:'from-pink-500',
        endGrad:'to-orange-400',
        content:'Ethical hackers learn and perform hacking in a professional manner, based on the direction of the client, and later, present a maturity scorecard '
    },
]